<template>
    <div>
    <carousel :per-page-custom="[[320,2],[780,4]]" :loop="true" :speed="1000" :autoplayTimeout="4000" 
       :paginationEnabled="false">
        <slide v-for="obj in papers" :key="obj.id">
            <v-flex xs10 md12 class="pa-3 mx-5" justify-space-around   > 
                <v-card width="200" height="200" elevation="3">
                    <a href="" @click="getEpaper(obj.id)">
                    <v-img
                        :src="$urlpath+obj.thumbnail"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="200px"
                    >
                        <v-card-title class="caption">{{obj.postdate|myDate}}</v-card-title>
                    </v-img>
                    </a>
                </v-card>
            </v-flex>
        </slide>
      
      </carousel>
        </div>
</template>

<script>
import Mainaxios from '../Api'
  export default {
    name: 'Cards',
    data: () => ({
        papers:[],
      
    }),
    created () {
        this.fetchData()
    },
    methods:{
        async fetchData(){
            await Mainaxios.get("api/recentEpapers").then(({data}) => (this.papers = data));
        },
        getEpaper(id){
            this.$router.push('/epaper/'+id)
        }
    }
  }
</script>
